import type { ReactNode } from 'react'
import './settingsKit.css'

export interface SettingsPageProps {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  children: ReactNode
  saveBar?: ReactNode
  className?: string
  testId?: string
  titleRef?: React.Ref<HTMLHeadingElement>
}

/**
 * SettingsPage (SR2, §3.3)
 * Top-level shell for settings tabs. Renders header + constrained content column + save bar slot.
 */
export function SettingsPage({
  title,
  subtitle,
  actions,
  children,
  saveBar,
  className,
  testId,
  titleRef,
}: SettingsPageProps) {
  return (
    <div
      className={['settingsKit', 'skPage', className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      <header className="skPage__header">
        <div className="skPage__headerTitles">
          <h1 className="skPage__title" ref={titleRef} tabIndex={-1}>{title}</h1>
          {subtitle ? <p className="skPage__subtitle">{subtitle}</p> : null}
        </div>
        {actions ? <div className="skPage__actions">{actions}</div> : null}
      </header>
      <div className="skPage__content">
        {children}
        {saveBar}
      </div>
    </div>
  )
}
